window.addEventListener('load', (event) => {
  if ( document.getElementById('contact_form') ) {
    document.getElementById('contact_submit').removeAttribute('disabled')
    document.getElementById('contact_form').addEventListener("submit", (e) => {
      
      var products = document.querySelectorAll('.enquiry-list li span');
      var collected_products = [];
      for (var i = 0; i < products.length; i++) {
        collected_products.push(products[i].textContent)
      }
      
      var form_data = JSON.stringify({
        contact_name: document.getElementById('contact_name').value,
        contact_email: document.getElementById('contact_email').value,
        contact_phone: document.getElementById('contact_phone').value,
        contact_address: document.getElementById('contact_address').value,
        contact_address2: document.getElementById('contact_address2').value,
        contact_city: document.getElementById('contact_city').value,
        contact_state: document.getElementById('contact_state').value,
        contact_postcode: document.getElementById('contact_postcode').value,
        contact_comments: document.getElementById('contact_comments').value,
        collected_products: collected_products,
      });
  
      sessionStorage.setItem("form_data", form_data);
    });
  }
 
});